// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c41a8d33","879":"00644221"}[chunkId] + ".chunk.js";
};